import { render, staticRenderFns } from "./yuns.vue?vue&type=template&id=9237ff4c&scoped=true&"
import script from "./yuns.vue?vue&type=script&lang=js&"
export * from "./yuns.vue?vue&type=script&lang=js&"
import style0 from "./yuns.vue?vue&type=style&index=0&id=9237ff4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9237ff4c",
  null
  
)

export default component.exports